import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=7d128a6d"
import script from "./ServerError.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServerError.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports